import { FunctionComponent, useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { handlingUrlParams } from "../../Utils/AppUtils";
import AdminServices from "services/admin-services";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import moment from "moment";
import AddJob from "./AddJob";
import ViewJob from "./ViewJob";

interface JobsProps {}

const Jobs: FunctionComponent<JobsProps> = () => {
  const [showPackageModel, setShowPackageModel] = useState<boolean>(false);
  const [selectedJob, setSelectedJob] = useState<any>(null);
  const [viewJobModel, setShowViewJobModel] = useState<boolean>(false);
  const [customerData, setCustomerData] = useState([] as any);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
  });

  useEffect(() => {
    // Load only if viewJobModel is false (so data isn’t refetched while viewing)
    if (!viewJobModel) {
      loadLazyData();
    }
  }, [lazyParams, viewJobModel]);

  const loadLazyData = () => {
    setLoading(true);
    AdminServices.getJobs(
      handlingUrlParams({
        PageNumber: lazyParams.page,
        PageSize: lazyParams.rows,
      })
    )
      .then((response: any) => {
        const parsedHeaders = JSON.parse(response.headers["x-pagination"]);
        setCustomerData(response.data);
        setTotalRecords(parsedHeaders.TotalCount);
        setLoading(false);
      })
      .catch((e: Error) => {
        console.error(e);
        setLoading(false);
      });
  };

  const onPage = (event: any) => {
    setLazyParams({
      ...lazyParams,
      first: event.first, // index of first record in current page
      rows: event.rows, // rows per page
      page: event.page + 1, // 1-based page for backend
    });
  };

  const onSort = (event: any) => {
    setLazyParams(event);
  };

  const renderViewBtn = (rowData: any) => (
    <Button
      onClick={() => {
        setSelectedJob(rowData);
        setShowViewJobModel(true);
      }}
      label="View Job"
      className="p-button-success p-button-outlined"
      style={{ padding: "5px 15px", fontSize: 12 }}
    />
  );

  const renderFilters = () => (
    <div className="flex flex-row justify-between items-center">
      <h2 className="text-xl font-bold">List of Jobs</h2>
      <Button
        onClick={() => setShowPackageModel(true)}
        label="Add Job"
        className="p-button-sm p-button-outlined p-button-success"
      />
    </div>
  );

  const CreatedDate = (rowData: any) => {
    const date = rowData?.createdDate;
    if (!date || !moment(date).isValid()) return <span>NA</span>;
    return <span>{moment(date).format("MM/DD/YYYY hh:mm A")}</span>;
  };

  // const renderStatus = (rowData: any) => {
  //   return (
  //     <>
  //       <div className="flex items-center">
  //         <Button
  //           label={rowData.status.name}
  //           className="p-button-success p-button-outlined"
  //           style={{ padding: "5px 15px", fontSize: 12 }}
  //         />
  //       </div>
  //     </>
  //   );
  // };

  return (
    <>
      {/* Jobs Table View */}
      {!viewJobModel && (
        <DataTable
          className="shadow-md"
          scrollable
          value={customerData}
          loading={loading}
          stripedRows
          lazy
          paginator
          filterDisplay="menu"
          responsiveLayout="scroll"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          dataKey="id"
          rowsPerPageOptions={[10, 20, 50]}
          emptyMessage="No Jobs found."
          totalRecords={totalRecords}
          rows={lazyParams.rows}
          first={lazyParams.first}
          onPage={onPage}
          onSort={onSort}
          sortOrder={lazyParams.sortOrder}
          header={renderFilters}
        >
          <Column field="id" header="Job Id" />
          <Column field="name" header="Name" />
          <Column field="description" header="Description" />
          <Column field="createdBy" header="Created By" />
          <Column body={CreatedDate} header="Created Date" />
          <Column body={renderViewBtn} header="" />
        </DataTable>
      )}

      {/* Add Job Sidebar */}
      <Sidebar
        visible={showPackageModel}
        position="right"
        style={{ minHeight: 500, width: 900 }}
        onHide={() => setShowPackageModel(false)}
      >
        <AddJob
          onClose={() => setShowPackageModel(false)}
          customerId={customerData?.[0]?.customerId}
          onSubmitSuccess={loadLazyData}
        />
      </Sidebar>

      {/* View Job Page */}
      {viewJobModel && (
        <ViewJob
          onClose={() => {
            // Just close and show table again — keep pagination intact
            setShowViewJobModel(false);
          }}
          customerId={customerData?.[0]?.customerId}
          jobData={selectedJob}
          onSubmitSuccess={loadLazyData}
        />
      )}
    </>
  );
};

export default Jobs;
